import { Injectable } from '@angular/core';
import { AssetEvent } from '../models/vr-events/AssetEvent';
import { VrEventAssetRelation } from '../models/vr-events/VrEventAssetRelation';
import { ApiVrEventService } from '../api-services/vr-event.api.service';
import { ApiVrEventAssetRelationService } from '../api-services/vr-event-asset-relation.api.service';
import { AssetInScene } from '../models/AssetInScene';
import { Scene } from '../models/Scene';
import { VrEvent } from '../models/vr-events/VrEvent';
import { VrEventTypeService } from './vr-event-type.service';
import { VrEventTriggerService } from './vr-event-trigger.service';
import { AssetTypeService } from './asset-type.service';
import { ModalController } from '@ionic/angular';
import { SceneEvent } from '../models/vr-events/SceneEvent';

@Injectable({
  providedIn: 'root'
})
export class VrEventService {


  
  public assetInScene: AssetInScene;
  public existingAssetsInScene: AssetInScene[] = []; 
  public scenes: Scene[] = [];
  public scene: Scene;
  public isAssetEvent: Boolean;

  constructor(
    public VrEventAPIService: ApiVrEventService,
    public VrEventAssetRelationAPIService: ApiVrEventAssetRelationService,
    public VrEventTypeService: VrEventTypeService,
    public VrEventTriggerService: VrEventTriggerService,
    public assetTypeService: AssetTypeService,
    public modalController: ModalController) { }

  // addAssetEventToDb(VrEvent, sceneAssetRelationId): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     this.VrEventAPIService.addVrEvent(VrEvent).subscribe(VrEvent => {

  //       var relation: VrEventAssetRelation = {
  //         VrEventAssetRelationId: 0,
  //         sceneAssetRelationId: sceneAssetRelationId,
  //         VrEventId: VrEvent.VrEventId
  //       }
  //       // console.log(relation);
  //       this.VrEventAssetRelationAPIService.addVrEventAssetRelation(relation).subscribe(VrEventAssetRelation => {
  //         var assetEvent: AssetEvent = new AssetEvent();    
  //         assetEvent.VrEventId = VrEvent.VrEventId,
  //         assetEvent.linkedContentId = VrEvent.linkedContentId,
  //         assetEvent.eventTypeId = VrEvent.eventTypeId,
  //         assetEvent.eventTriggerId = VrEvent.eventTriggerId,
  //         assetEvent.sceneAssetRelationId = VrEventAssetRelation.sceneAssetRelationId;
  //         resolve(assetEvent);
  //       })
  //     })
  //   }) 
  // }

  setUpSceneEvent(currentScene: Scene, existingAssets: AssetInScene[], scenes: Scene[]) {
    this.assetInScene = null;
    this.scene = currentScene;
    this.existingAssetsInScene = existingAssets;
    this.scenes = scenes;
    this.isAssetEvent = false;
  }

  setUpAssetEvent(assetInScene: AssetInScene, existingAssets: AssetInScene[], scenes: Scene[], currentScene: Scene) {
    this.scene = currentScene;
    this.assetInScene = assetInScene;
    this.existingAssetsInScene = existingAssets;
    this.scenes = scenes;
    this.isAssetEvent = true;
  }

  removeEvent(vrEvent: VrEvent, element): Promise<void>{
    // if assetEvent has VrEventId then it is in the database.
    return new Promise((resolve) => {
      if(vrEvent.vrEventId){
        this.VrEventAPIService.deleteVrEvent(vrEvent.vrEventId).subscribe(removedEvent => {
          var vrEvent = element.events.filter(e => e.vrEventId == removedEvent.vrEventId)[0];
          var vrEventIndex = element.events.indexOf(vrEvent);
          element.events.splice(vrEventIndex, 1);
          resolve();
        },
        err => {
          resolve();
        });
      }else{
        //if(this.isAssetEvent){
        var assetEventIndex = element.events.indexOf(vrEvent as AssetEvent);
        element.events.splice(assetEventIndex, 1);
        resolve();
      }
    });
  }
    
  getNumberOfEvents(){
    if(this.isAssetEvent && this.assetInScene.events){
      return this.assetInScene.events.length; //.filter(c => c.toBeRemoved == false).length;
    }
    else if (this.isAssetEvent == false && this.scene.events){
      return this.scene.events.length; //.filter(c => c.toBeRemoved == false).length;
    }
    return 0;
  }

  getActiveAssetsInScene(){
    var currentSceneId: number;
    if(this.isAssetEvent){
      currentSceneId = this.assetInScene.sceneAssetRelation.sceneId;
    }else if(!this.isAssetEvent){
      currentSceneId = this.scene.sceneId;
    }

    return this.existingAssetsInScene.filter(a => a.sceneAssetRelation.sceneId == currentSceneId).filter(a => a.toBeRemoved == false);
  }

  getActiveAssetEvents(){
    return this.assetInScene.events; //.filter(e => e.toBeRemoved == false);
  }

  getActiveSceneEvents(){
    return this.scene.events; //.filter(e => e.toBeRemoved == false);
  }

  isObjectEventType(eventTypeId): boolean{
    if((this.getEventType(eventTypeId) == 'Show Object') || (this.getEventType(eventTypeId) == 'Hide Object') || (this.getEventType(eventTypeId) == 'Move Object') || (this.getEventType(eventTypeId) == "Toggle Visibility")){
      return true;
    }else{
      return false;
    }
  }

  isMediaEventType(eventTypeId): boolean {
    var eventType = this.getEventType(eventTypeId);
    if((eventType == 'Play Media') || (eventType == 'Toggle Media') || (eventType == 'Stop Media')){
      return true;
    }
    return false;
  }

  isAssetVideoOrAudio(assetTypeId) : boolean{
   var assetType = this.getAssetType(assetTypeId);
    if(assetType== 'Video' || assetType == 'Audio'){
      return true;
    }
    return false;
  }

  doesSceneIdMatchCurrentScene(sceneIdToCheck: number): boolean{
    if(this.isAssetEvent == true && sceneIdToCheck == this.assetInScene.sceneAssetRelation.sceneId){
      return true;
    }else if(this.isAssetEvent == false && sceneIdToCheck == this.scene.sceneId){
      return true;
    }
    return false;
  }

  // This adds an event to the database and pushes to event to the assetInScene.events when the user selects 'Add Event' button.
  addEvent(){
    var VrEvent: VrEvent = this.getNewVrEvent();

    // assetEvent.sceneAssetRelationId = this.assetInScene.sceneAssetRelation.sceneAssetRelationId;
    if(this.isAssetEvent){
      if (this.getAssetType(this.assetInScene.baseAsset.assetTypeId) == 'Audio'){
        // if audio asset, sound clip ending triggers event
        VrEvent.eventTriggerId = 3; 
      }
  
        var assetEvent: AssetEvent = new AssetEvent();    
        assetEvent.vrEventId = VrEvent.vrEventId,
        assetEvent.linkedContentId = VrEvent.linkedContentId,
        assetEvent.eventTypeId = VrEvent.eventTypeId,
        assetEvent.eventTriggerId = VrEvent.eventTriggerId,
  
        this.assetInScene.events.push(assetEvent);
    }else{
      // add scene events here

        var sceneEvent: SceneEvent = new SceneEvent();    
        sceneEvent.vrEventId = VrEvent.vrEventId,
        sceneEvent.linkedContentId = VrEvent.linkedContentId,
        sceneEvent.eventTypeId = VrEvent.eventTypeId,
        sceneEvent.eventTriggerId = VrEvent.eventTriggerId,
        sceneEvent.timeOfEvent = 0;
        this.scene.events.push(sceneEvent);
    }
  }

  getNewVrEvent(): VrEvent{
    return {
      'vrEventId': 0,
      'eventTypeId': 2,
      'linkedContentId': -1,
      'eventTriggerId': 1,
    }
  }

  getNewSceneEvent(scene: Scene): SceneEvent{
    return {
      'vrEventId': 0,
      'eventTypeId': 2,
      'linkedContentId': -1,
      'eventTriggerId': 1,
      'sceneId': scene.sceneId,
      'timeOfEvent': 0
    }
  }

  getEventTypes(){
    return this.VrEventTypeService.types;
  }

  getEventType(eventTypeId){
    return this.VrEventTypeService.getType(eventTypeId);
  }

  getEventTrigger(eventTriggerId){
    return this.VrEventTriggerService.getTrigger(eventTriggerId);
  }

  getAssetType(assetTypeId){
    return this.assetTypeService.getType(assetTypeId);
    
  }
  
  // author.service.ts handles the OnDidDismiss()
  saveChanges(){
    this.modalController.dismiss();
  }

  //#region REGION FOR HANDLING MOVE OBEJCT EVENT
  
  // selectNewAssetPosition (assetInScene: AssetInScene, eventIndex){
  //   this.moveObjectEventService.triggeringAsset = assetInScene;

  //   var linked = this.existingAssetsInScene[assetInScene.events[eventIndex].linkedContentId];
  //   this.moveObjectEventService.movingAsset = linked;
  //   this.moveObjectEventService.pos = linked.sceneAssetRelation.position;
  //   this.moveObjectEventService.settingMoveObjectEvent = true;
  //   this.moveObjectEventService.eventIndex = eventIndex;

  //   this.hideModal();
  // }

  hideModal(){
    if (document.getElementById('add-object-events-modal')){
      document.getElementById('add-object-events-modal').style.display = 'none';
    }
    if (document.getElementById('add-object-events-modal-question')){
      document.getElementById('add-object-events-modal-question').style.display = 'none';
    }
  }


}
